import { render, staticRenderFns } from "./info-registration.vue?vue&type=template&id=4ba88e03&scoped=true&"
import script from "./info-registration.vue?vue&type=script&lang=js&"
export * from "./info-registration.vue?vue&type=script&lang=js&"
import style0 from "./info-registration.vue?vue&type=style&index=0&id=4ba88e03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba88e03",
  null
  
)

export default component.exports